import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { UseQueryResult, useQuery } from 'react-query';
import { UncreditedReservationsTotal } from 'types';
import { client } from 'utils/api-client';

interface UseTotalUncreditedReservationsProps {
  startDate: string;
  endDate: string;
}

export const TOTAL_UNCREDITED_RESERVATIONS_QUERY_KEY = 'total-uncredited-reservations';

/**
 * Hook to fetch the total count of uncredited reservations within a date range.
 * @param start_date - Start date in ISO format (YYYY-MM-DD)
 * @param end_date - End date in ISO format (YYYY-MM-DD)
 */
function useTotalUncreditedReservations({
  startDate,
  endDate,
}: UseTotalUncreditedReservationsProps): UseQueryResult<AxiosResponse<UncreditedReservationsTotal>> {
  const fetchTotalUncreditedReservations = useCallback(
    () =>
      client.get('/reports/reservations/uncredited-reservations/total', {
        params: {
          start_date: startDate,
          end_date: endDate,
        },
      }),
    [startDate, endDate],
  );

  return useQuery({
    queryKey: [TOTAL_UNCREDITED_RESERVATIONS_QUERY_KEY, startDate, endDate],
    queryFn: fetchTotalUncreditedReservations,
    enabled: Boolean(startDate && endDate),
  });
}

export default useTotalUncreditedReservations;
